/**
 * `/hosting/new-listing` has no content of its own — steps live at
 * `/hosting/new-listing/details` etc. Landing here (history back, deep link,
 * or a bad push) used to paint a blank screen under the wizard header.
 *
 * Always bounce into the first step (or hosting if we cannot mount the wizard).
 */
import { useEffect } from 'react'
import { View } from 'react-native'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { ScreenContainer } from '@/components/ui/ScreenContainer'
import { Skeleton } from '@/components/ui/Skeleton'
import { SPACING, RADIUS } from '@/lib/theme/tokens'

export default function NewListingIndexRedirect() {
  const router = useRouter()
  const { vehicleId } = useLocalSearchParams<{ vehicleId?: string }>()

  useEffect(() => {
    const qs = vehicleId ? `?vehicleId=${encodeURIComponent(vehicleId)}` : ''
    router.replace(`/hosting/new-listing/details${qs}` as never)
  }, [router, vehicleId])

  return (
    <ScreenContainer variant="content" scroll={false}>
      <View style={{ padding: SPACING.md, gap: SPACING.md }} testID="listing.index-redirect">
        <Skeleton width="55%" height={26} borderRadius={RADIUS.sm} />
        <Skeleton width="100%" height={4} borderRadius={RADIUS.full} />
        <Skeleton width="100%" height={48} borderRadius={RADIUS.md} />
      </View>
    </ScreenContainer>
  )
}
